import { Action } from "redux";
import { GetMeCustomerByCustomerTopPageResponse } from "../response/customer_response";

export enum CustomerTopPageActionType {
  REQUEST_GET_ME_CUSTOMER_BY_TOP_PAGE = "CUSTOMER_TOP_PAGE_REQUEST_GET_ME_CUSTOMER",
  CALLBACK_GET_ME_CUSTOMER_BY_TOP_PAGE = "CUSTOMER_TOP_PAGE_CALLBACK_GET_ME_CUSTOMER",

  REQUEST_START_STANDARD_PLAN_BY_TOP_PAGE = "CUSTOMER_PLAN_REQUEST_START_STANDARD_PLAN_BY_TOP_PAGE",
  CALLBACK_START_STANDARD_PLAN_BY_TOP_PAGE = "CUSTOMER_PLAN_CALLBACK_START_STANDARD_PLAN_BY_TOP_PAGE",
}

export interface IRequestGetMeCustomerByTopPageAction extends Action {
  type: CustomerTopPageActionType.REQUEST_GET_ME_CUSTOMER_BY_TOP_PAGE;
}

export interface ICallbackGetMeCustomerByTopPageAction extends Action {
  type: CustomerTopPageActionType.CALLBACK_GET_ME_CUSTOMER_BY_TOP_PAGE;
  isSuccess: boolean;
  item?: GetMeCustomerByCustomerTopPageResponse;
}

export type CustomerTopPageAction =
  | IRequestGetMeCustomerByTopPageAction
  | ICallbackGetMeCustomerByTopPageAction;

export interface ICustomerTopPageActionCreator {
  requestGetMeCustomerByTopPageAction(): IRequestGetMeCustomerByTopPageAction;

  callbackGetMeCustomerByTopPageAction(
    isSuccess: boolean,
    items?: GetMeCustomerByCustomerTopPageResponse
  ): ICallbackGetMeCustomerByTopPageAction;
}

class ActionCreator implements ICustomerTopPageActionCreator {
  public requestGetMeCustomerByTopPageAction =
    (): IRequestGetMeCustomerByTopPageAction => {
      return {
        type: CustomerTopPageActionType.REQUEST_GET_ME_CUSTOMER_BY_TOP_PAGE,
      };
    };

  public callbackGetMeCustomerByTopPageAction = (
    isSuccess: boolean,
    item?: GetMeCustomerByCustomerTopPageResponse
  ): ICallbackGetMeCustomerByTopPageAction => {
    return {
      type: CustomerTopPageActionType.CALLBACK_GET_ME_CUSTOMER_BY_TOP_PAGE,
      isSuccess,
      item,
    };
  };
}

export const createCustomerTopPageActionCreator =
  (): ICustomerTopPageActionCreator => {
    return new ActionCreator();
  };



// WEBPACK FOOTER //
// ./src/presentation/action/customer_top_page_action.ts